import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

import { toast } from "react-toastify";

export const UploadDocumentModal = ({ t, show, onHide, onUpload }) => {
    const ALLOWED_MIME_TYPES = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
        "application/rtf",
        "application/vnd.oasis.opendocument.text",
        "image/jpeg",
        "image/png",
    ];

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // ✅ 5MB validation
        if (file.size > 5 * 1024 * 1024) {
            toast.warning("Prescription file size should be less than 5MB");
            return;
        }

        // Type check
        if (!ALLOWED_MIME_TYPES.includes(file.type)) {
            toast.warning("Unsupported file format");
            return;
        }

        onUpload(file);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("Upload Prescription")}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Control
                            type="file"
                            accept="
		.pdf,
		.doc,
		.docx,
		.txt,
		.rtf,
		.odt,
		.jpg,
		.jpeg,
		.png
	"
                            onChange={handleFileChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

